import { sendPostRequest } from "@/utils/sendPostRequest";
import { ContactFormValues } from "./sendContactForm";

export type ContactData = {
  agencyName: string;
  agencyType: string;
  companyName: string;
  contactName: string;
  phoneNumber: string;
  email: string;
  demandMessage: string;
};

export const sendContactDemand = async (contactData: ContactFormValues) => {
  const data: ContactData = {
    agencyName: contactData.agencySelected.agencyName,
    agencyType: contactData.agencySelected.agencyType,
    companyName: contactData.socialReason,
    contactName: contactData.lastname,
    phoneNumber: contactData.telephone,
    email: contactData.email,
    demandMessage: contactData.demand,
  };
  try {
    await sendPostRequest({
      url: "/company/v1/createContactDemand",
      isPrisme: false,
      body: JSON.stringify(data),
      additionalHeaders: [{ name: "Content-Type", value: "application/json" }],
    });
  } catch (error) {
    console.error(
      "An error occurred while submitting the contact demand.",
      error
    );
  }
};
